"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHTMLAttr = exports.replace = exports.mangle = exports.getText = exports.buildImg = void 0;
function mangle(text) {
    let out = '';
    for (let i = 0; i < text.length; i += 1) {
        let ch = text.charCodeAt(i);
        if (Math.random() > 0.5) {
            ch = `x${ch.toString(16)}`;
        }
        out += `&#${ch};`;
    }
    return out;
}
exports.mangle = mangle;
function getText(textSource) {
    if (Array.isArray(textSource)) {
        return textSource
            .map((element) => (typeof element === 'string' ? element : element.text))
            .join('');
    }
    if (typeof textSource === 'string') {
        return textSource;
    }
    return textSource === null || textSource === void 0 ? void 0 : textSource.text;
}
exports.getText = getText;
// this returns any since its complex to handle something that returns a recursive function or a RegExp
function replace(regex, opt) {
    let newRegex = regex.source;
    opt = opt || '';
    return function self(name, val) {
        if (!name) {
            return new RegExp(newRegex, opt);
        }
        let newVal = val.source || val;
        newVal = newVal.replace(/(^|[^\[])\^/g, '$1');
        newRegex = newRegex.replace(name, newVal);
        return self;
    };
}
exports.replace = replace;
function htmlAttrRegexFactory(attr) {
    return new RegExp(` ${attr}=([\\"\\'])?(?<${attr}>(?:.(?!\\1|>))*.?)\\1`, 'i');
}
const getHTMLAttr = ['href', 'target', 'title'].reduce((res, attr) => {
    const regex = htmlAttrRegexFactory(attr);
    return Object.assign(Object.assign({}, res), { [attr]: (input) => {
            const match = regex.exec(input);
            return match ? match.groups[attr] : null;
        } });
}, {});
exports.getHTMLAttr = getHTMLAttr;
function buildImg(src) {
    const srcAttr = src ? ` src="${src}"` : '';
    return `<img${srcAttr} />`;
}
exports.buildImg = buildImg;
